import theme from 'ThemeProvider/theme';
import sx from 'utils/createSx';

export const BAR = {
  ink: '#2b2a28',
  copper: '#d97a1f',
  copperBright: '#e8922e',
  cream: '#faf9f6',
} as const;

export const displayFont =
  '"Cormorant Garamond", "Cormorant", Georgia, "Times New Roman", serif';

export default sx({
  page: {
    pb: 8,
  },
  hero: {
    width: '100vw',
    maxWidth: '100vw',
    position: 'relative',
    left: '50%',
    right: '50%',
    ml: '-50vw',
    mr: '-50vw',
    mt: -4,
    minHeight: { xs: 'auto', md: 520 },
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'stretch', md: 'center' },
    overflow: 'hidden',
    bgcolor: { xs: '#fff', md: BAR.ink },
  },
  heroImageMobile: {
    display: { xs: 'block', md: 'none' },
    position: 'relative',
    width: '100%',
    height: { xs: 'min(58svh, 480px)', sm: 520 },
    objectFit: 'contain',
    objectPosition: 'center top',
  },
  heroImageDesktop: {
    display: { xs: 'none', md: 'block' },
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  heroOverlay: {
    display: { xs: 'none', md: 'block' },
    position: 'absolute',
    inset: 0,
    background:
      'linear-gradient(to right, rgba(43,42,40,0.88) 0%, rgba(43,42,40,0.4) 55%, transparent 100%)',
  },
  heroContent: {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    px: { xs: 2.5, sm: 4 },
    py: { xs: 3, md: 8 },
    maxWidth: 720,
  },
  heroEyebrow: {
    fontSize: '0.72rem',
    letterSpacing: '0.32em',
    textTransform: 'uppercase',
    color: { xs: BAR.copper, md: BAR.copperBright },
    fontWeight: 500,
  },
  heroTitle: {
    mt: 2,
    fontFamily: displayFont,
    fontSize: { xs: '2.25rem', md: '3.75rem' },
    lineHeight: 1.08,
    fontWeight: 400,
    color: { xs: BAR.ink, md: BAR.cream },
  },
  heroSubtitle: {
    mt: 2,
    maxWidth: 520,
    fontSize: { xs: '1rem', md: '1.2rem' },
    lineHeight: 1.6,
    color: { xs: 'rgba(43,42,40,0.78)', md: 'rgba(250,249,246,0.9)' },
  },
  catalogSection: {
    pt: { xs: 4, md: 6 },
  },
  catalogTitle: {
    fontWeight: 700,
    mb: 1,
    color: theme.palette.text.primary,
  },
  catalogSubtitle: {
    mb: 4,
    color: theme.palette.text.secondary,
  },
  subsection: {
    mt: { xs: 4, md: 6 },
    mb: 2,
  },
  subsectionTitle: {
    fontFamily: displayFont,
    fontSize: { xs: '1.75rem', md: '2.25rem' },
    fontWeight: 400,
    color: theme.palette.text.primary,
    mb: 0.5,
  },
  subsectionSubtitle: {
    mb: 3,
    color: theme.palette.text.secondary,
  },
  formCard: {
    p: 3,
    mb: 3,
  },
  deliveryOption: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 2,
    p: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
